import React, { useState } from 'react';
import { motion } from 'framer-motion';

const QRCodeVisual = () => {
  const size = 170;
  const cell = size / 21;
  const pattern = [
    [1,1,1,1,1,1,1,0,1,0,1,0,1,1,1,1,1,1,1,0,0],
    [1,0,0,0,0,0,1,0,0,1,0,1,0,1,0,0,0,0,1,0,1],
    [1,0,1,1,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,0],
    [1,0,1,1,1,0,1,0,0,1,0,1,0,1,0,1,1,0,1,0,1],
    [1,0,1,1,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,1,0],
    [1,0,0,0,0,0,1,0,0,1,0,1,0,1,0,0,0,0,1,0,1],
    [1,1,1,1,1,1,1,0,1,0,1,0,1,1,1,1,1,1,1,0,0],
    [0,0,0,0,0,0,0,0,1,1,0,1,0,0,0,0,0,0,0,1,0],
    [1,1,0,1,1,0,1,0,0,0,1,0,1,1,0,1,0,0,1,0,1],
    [0,1,0,0,1,0,0,1,1,0,0,1,0,1,1,0,1,1,0,1,0],
    [1,0,1,0,1,1,1,0,0,1,1,0,1,0,0,1,1,0,1,0,1],
    [0,1,0,1,0,1,0,1,0,0,1,0,0,1,0,1,0,1,0,1,0],
    [1,1,1,0,1,0,1,0,1,1,0,1,1,0,1,0,1,0,1,0,1],
    [0,0,0,0,0,0,0,0,1,0,1,0,0,1,0,1,0,1,0,1,0],
    [1,1,1,1,1,1,1,0,0,1,0,1,1,0,1,1,0,0,1,0,1],
    [1,0,0,0,0,0,1,0,1,0,1,0,0,1,0,1,1,1,0,1,0],
    [1,0,1,1,1,0,1,0,0,1,1,0,1,0,1,0,0,0,1,0,1],
    [1,0,1,1,1,0,1,0,1,0,0,1,0,1,0,1,1,1,0,1,0],
    [1,0,1,1,1,0,1,0,0,1,1,0,1,0,1,0,0,0,1,0,1],
    [1,0,0,0,0,0,1,0,1,1,0,1,0,1,0,1,1,1,0,0,0],
    [1,1,1,1,1,1,1,0,0,0,1,0,1,0,1,0,0,0,1,1,0],
  ];
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
      {pattern.map((row, r) =>
        row.map((v, c) => v === 1 ? (
          <rect key={`${r}-${c}`} x={c * cell + 0.5} y={r * cell + 0.5} width={cell - 0.5} height={cell - 0.5} rx="0.8" fill="#0F0F0F" />
        ) : null)
      )}
      <rect x={size/2-17} y={size/2-17} width="34" height="34" rx="6" fill="white" />
      <rect x={size/2-13} y={size/2-13} width="26" height="26" rx="4" fill="#D4AF37" />
      <text x={size/2} y={size/2+7} textAnchor="middle" fontSize="17" fontWeight="800" fill="#0F0F0F" fontFamily="Inter,sans-serif">S</text>
    </svg>
  );
};

const MyQR = ({ onBack, onToast, t, isRTL }) => {
  const [copied, setCopied] = useState(false);

  const tr = t || {
    myQRTitle: 'My QR Code', shareDesc: 'Share this code to receive payments',
    walletId: 'SimoPay ID', copy: 'Copy', copied: '✓ Copied', share: 'Share ↗', saveQR: 'Save QR',
  };

  const handleCopy = () => {
    setCopied(true);
    onToast('SimoPay ID copied to clipboard!');
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div
      data-testid="myqr-screen"
      className="no-scrollbar"
      style={{
        background: '#0F0F0F',
        height: '100%',
        fontFamily: 'Inter, sans-serif',
        overflowY: 'auto',
        paddingBottom: '12px',
        direction: isRTL ? 'rtl' : 'ltr',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '18px 20px 14px' }}>
        <motion.button
          whileTap={{ scale: 0.9 }}
          onClick={onBack}
          style={{ width: '32px', height: '32px', borderRadius: '10px', background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.08)', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: '#F5F1EA', fontSize: '16px', flexShrink: 0 }}
        >
          {isRTL ? '→' : '←'}
        </motion.button>
        <h2 style={{ color: '#F5F1EA', fontSize: '17px', fontWeight: '700', margin: 0, letterSpacing: '-0.4px' }}>{tr.myQRTitle}</h2>
      </div>

      <div style={{ padding: '4px 20px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <p style={{ color: '#8B93A7', fontSize: '12px', marginBottom: '22px', textAlign: 'center' }}>{tr.shareDesc}</p>

        <motion.div
          initial={{ scale: 0.88, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
          style={{ background: '#FFFFFF', borderRadius: '22px', padding: '22px', boxShadow: '0 20px 60px rgba(0,0,0,0.6)', marginBottom: '18px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px', width: '220px' }}
        >
          <QRCodeVisual />
          <div style={{ textAlign: 'center' }}>
            <p style={{ color: '#0F0F0F', fontSize: '13px', fontWeight: '700', margin: '0 0 1px' }}>Ahmed</p>
            <p style={{ color: '#8B93A7', fontSize: '11px', margin: 0 }}>ahmed@simopay</p>
          </div>
        </motion.div>

        <div style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.07)', borderRadius: '14px', padding: '13px 16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', marginBottom: '14px' }}>
          <div>
            <p style={{ color: '#8B93A7', fontSize: '9px', margin: '0 0 2px', textTransform: 'uppercase', letterSpacing: '0.8px' }}>{tr.walletId}</p>
            <p style={{ color: '#F5F1EA', fontSize: '13px', fontWeight: '600', margin: 0 }}>ahmed@simopay</p>
          </div>
          <motion.button
            data-testid="copy-wallet-id"
            whileTap={{ scale: 0.9 }}
            onClick={handleCopy}
            style={{ background: copied ? 'rgba(74,222,128,0.1)' : 'rgba(212,175,55,0.08)', border: copied ? '1px solid rgba(74,222,128,0.2)' : '1px solid rgba(212,175,55,0.15)', borderRadius: '9px', padding: '5px 11px', color: copied ? '#4ADE80' : '#D4AF37', fontSize: '11px', fontWeight: '600', cursor: 'pointer', transition: 'all 0.2s', flexShrink: 0 }}
          >
            {copied ? tr.copied : tr.copy}
          </motion.button>
        </div>

        <div style={{ display: 'flex', gap: '10px', width: '100%' }}>
          <motion.button whileTap={{ scale: 0.96 }} style={{ flex: 1, background: 'linear-gradient(135deg, #D4AF37, #B8962E)', color: '#0F0F0F', border: 'none', borderRadius: '13px', padding: '13px', fontSize: '13px', fontWeight: '700', cursor: 'pointer' }}>
            {tr.share}
          </motion.button>
          <motion.button whileTap={{ scale: 0.96 }} style={{ flex: 1, background: 'rgba(255,255,255,0.04)', color: '#F5F1EA', border: '1px solid rgba(255,255,255,0.08)', borderRadius: '13px', padding: '13px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}>
            {tr.saveQR}
          </motion.button>
        </div>
      </div>
    </div>
  );
};

export default MyQR;
